import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
	state:{
		//excelUrl:'http://power.btiot.com.cn/',
		excelUrl: (('https:' == document.location.protocol) ?'https':'http') +'://'+window.location.host+'/',
		AlarmInfo:{
			"Total":0,//报警设备数量
			'im':[],//最近1分钟内报警
			"EF_OffLine":"0",//电气火灾离线数量
			"EF_Alarm":"0",//电气火灾报警数量
			"EF_GQY":'0',
			"EF_GZ":"0",
			"EF_LD":"0",
			"EF_CW":'0',
			"EF_YW":"0",
			"SMOKE_Alarm":"0",//烟感离线数量
			"SMOKE_OffLine":"0"//烟感报警数量
		},
		homeCity:'',
		mainPort:{
			style:{
				navColor:'green',
				leftNavColor:'site-menubar-light'
			},
			admin:{
				getCustomerArr:[],
				getDqCustomerID:'',//管理员账号，项目列表中，选择了具体项目，把具体项目的值保存，以获取正确的分组
				getCustomerID:'',
				needCheck:false
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/vuex/store.js